import livingRoomFireplace from "../../public/beckenhamlivingroom/3.webp";
import kitchen from "../../public/kentkitchen/1.webp";
import sofa from "../../public/beckenhamlivingroom/1.jpg";
import map from "../../public/map.jpg";

export const routes = [
  "About",
  "Our Story",
  "How we can help",
  "Projects",
  "Services",
  "Contact",
  "Testimonials",
];

export const services = [
  {
    route: "essentials",
    name: "Essentials Package",
    description:
      "Our Essentials Package is perfect for clients seeking a professional interior design consultation to begin their design journey. This package includes:",
    summary: [
      {
        offer: "Space and layout assessment",
        offerDetail: "Discussing your needs, style, theme, and any challenges.",
      },
      {
        offer: "Site survey",
        offerDetail:
          "Taking measurements, photos, and creating initial floor plans.",
      },
      {
        offer: "2-3 hours on-site consultation",
        offerDetail: "Tailored advice and personalised recommendations.",
      },
      {
        offer: "Follow-up report",
        offerDetail: "A written summary and concept board with design ideas.",
      },
    ],
    price: "£300 per room",
    image: { src: livingRoomFireplace, alt: "Living room fireplace" },
  },
  {
    route: "enhanced",
    name: "Enhanced Package",
    description: `Our Enhanced Package offers a more detailed interior design concept and planning service, building on the Essentials Package. This includes:`,
    summary: [
      {
        offer: "Digital Concept Development",
        offerDetail:
          "A product/design board featuring a cohesive colour scheme.",
      },
      {
        offer: "Spatial Planning",
        offerDetail:
          "Scaled floor plans with furniture layout to maximise space.",
      },
      {
        offer: "Detailed Information Pack",
        offerDetail:
          "Finalised concept board, full report, and suggested sources.",
      },
      {
        offer: "Shopping list & tips",
        offerDetail: "A clickable list of recommended products and suppliers.",
      },
    ],
    price: "From £800 (subject to project scope)",
    image: { src: kitchen, alt: "Kitchen oven" },
  },
  {
    route: "signature",
    name: "Signature Package",
    description:
      "Our Signature Package offers comprehensive design solutions, providing a full-service experience where we handle every aspect of your project from concept to completion. This package includes:",
    summary: [
      {
        offer: "3D visuals/renders and modelling",
        offerDetail: "To bring the design to life.",
      },
      {
        offer: "Physical fabric, textile & flooring samples",
        offerDetail: "Provided where possible.",
      },
      {
        offer: "Bespoke joinery design & solutions",
        offerDetail: "Where required.",
      },
      {
        offer: "Access to our numerous trade discounts",
        offerDetail: "With procurement.",
      },
      {
        offer: "Product sourcing and procurement",
        offerDetail:
          "Furniture, fixtures, and fittings, including a shopping list of suppliers and costs.",
      },
      {
        offer: "Paint suggestions",
        offerDetail: "",
      },
      {
        offer: "Implementation of agreed design",
        offerDetail: "",
      },
      {
        offer: "Two further in-person design consultations",
        offerDetail: "(additional site visits charged hourly)",
      },
      {
        offer: "Ongoing Designer Support",
        offerDetail:
          "Support and check-ins throughout the project to keep everything on track.",
      },
    ],
    price: "Price subject to project scope",
    image: { src: sofa, alt: "Sofa" },
  },
  {
    route: "anywheredesign",
    name: "Anywhere Design Service",
    description:
      "If you're based further afield than Beckenham and its surrounding areas, we can still help you. Our Anywhere Design Service offers a comprehensive design experience through online consultations, with clear guidance and easy implementation. This package includes:",
    summary: [
      {
        offer: "Initial online consultation",
        offerDetail:
          "A video call to discuss your space, style, and design challenges.",
      },
      {
        offer: "Site survey guide",
        offerDetail:
          "A simple guide to help you take your own measurements, photos, and notes for accurate design planning.",
      },
      {
        offer: "Digital concept development",
        offerDetail:
          "A cohesive design board featuring colour schemes, furniture layout, and inspirational product recommendations.",
      },
      {
        offer: "Step-by-step implementation guide",
        offerDetail:
          "A detailed, easy-to-follow plan for executing the design with clear instructions for sourcing and arranging your space.",
      },
      {
        offer: "Email support",
        offerDetail:
          "Follow-up support with answers to any questions you may have during the process.",
      },
    ],
    price: "£450 per room (subject to project scope)",
    image: {
      src: map,
      alt: "Map showing the radius that K & K Interior Design studio cover ",
    },
    addOns: [
      {
        offer: "Sourcing Help & Clickable Shopping List",
        offerDetail:
          "We can provide personalised product recommendations and a clickable shopping list with links to suppliers, making purchasing easy and convenient.",
      },
    ],
    addOnPrice:
      "Priced on application (we'll tailor it to suit your needs and budget)",
  },
];
